import setAvatar from "./components/setAvatar";
import {copyTextToClipboard, saveError} from './components/helpers';

import popup from "./components/popup";
window.popup = popup;
$(document).ready(async ()=> {

    window.lang = $('#lang').data('lang');


    const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl)
    });



    $('.clipboard').dblclick(() => {
        copyTextToClipboard($('.clipboard').val());
        popup.warning('Copied');
    });

    setAvatar();

});
